import React, { useEffect } from 'react';
import UiContent from '../../../Components/Common/UiContent';
import BreadCrumb from '../../../Components/Common/BreadCrumb';
import { Container } from 'reactstrap';
import PowerGenerationHourMeterList from './PowerGenerationHourMeterList';
import { useParams } from 'react-router-dom';
import useRedirectEstablishmentActiveContent from '../../../Components/Hooks/useRedirectEstablishmentActiveContent';

//redux

const PowerGenerationHourMeter = () => {
	const { id } = useParams();
	const redirectEstablishmentActiveContent = useRedirectEstablishmentActiveContent('/operation/hour-meter/establishmentId');
	
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio', icon: 'icon-house' },
		{ to: '#', label: 'Operaciones', icon: 'icon-wrench' },
	];


	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Registrar Horómetro/Consumo' links={breadcrumbLinks} icon={'icon-circle-gauge'} />
					<PowerGenerationHourMeterList establishment_id={id} />
				</Container>
			</div>
		</React.Fragment>
	);
};

export default PowerGenerationHourMeter;
